import React from 'react';
import { Link } from 'react-router-dom';
import { FaExternalLinkAlt } from 'react-icons/fa';

export default function LinkButton({ to, label }) {
  return (
    <div className="">
      <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4 mb-2 -mt-2 sm:-mr-7">
        <div> </div>
        <div className="col-span-3 sm:col-span-2 flex justify-center sm:justify-end">
          <Link
            to={to}
            className={`text-base flex gap-1 items-center justify-center font-medium text-primary-500 px-2 py-1 rounded border border-primary mx-3 hover:bg-primary hover:text-white transition focus:ring-primary focus:ring-2 focus:ring-offset-2`}
          >
            {label}
            <FaExternalLinkAlt className="mb-[2px]" />
          </Link>
        </div>
      </div>
    </div>
  );
}
